import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { BadgeCheckIcon, XIcon } from 'lucide-react';
import { purchaseNotifications } from '../data/content';
const VISIBLE_MS = 6000;
const HIDDEN_MS = 7000;
export function PurchaseNotification() {
  const [index, setIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);
  useEffect(() => {
    if (isDismissed) return;
    const timeout = window.setTimeout(() => {
      if (isVisible) {
        setIsVisible(false);
        setIndex(prev => (prev + 1) % purchaseNotifications.length);
      } else {
        setIsVisible(true);
      }
    }, isVisible ? VISIBLE_MS : HIDDEN_MS);
    return () => window.clearTimeout(timeout);
  }, [isVisible, isDismissed]);
  const item = purchaseNotifications[index];
  return <div aria-live="polite" className="pointer-events-none fixed bottom-4 left-4 z-40 max-w-[calc(100vw-2rem)]" data-id="element-155" data-mp="hhgxttea7lcr">
      <AnimatePresence data-id="element-156" data-mp="1sgfs9qnz2eh0">
        {isVisible && !isDismissed && <motion.div key={`${item.name}-${index}`} initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: 16
      }} transition={{
        duration: 0.35,
        ease: 'easeOut'
      }} className="pointer-events-auto flex items-center gap-3 rounded-2xl bg-white px-4 py-3 shadow-soft ring-1 ring-ink/10" data-id="element-157" data-mp="1xf94zgvfq1g4">
            <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-brand-light text-brand" data-id="element-158" data-mp="1egeoa2ceuqxb">
              <BadgeCheckIcon className="h-5 w-5" aria-hidden="true" data-id="element-159" data-mp="zsjt8faxkah2" />
            </span>
            <div className="pr-2" data-id="element-160" data-mp="14rd8ac5v89jc">
              <p className="text-xs font-bold text-ink" data-id="element-161" data-mp="14o8z10djmnlt">
                <span aria-hidden="true" data-id="element-162" data-mp="qrlp7x0hs2yh">✨ </span>
                {item.name} — {item.location}
              </p>
              <p className="text-[11px] font-semibold text-ink/60" data-id="element-163" data-mp="voc5olg7l0kf">
                Just purchased{' '}
                <span className="text-brand" data-id="element-164" data-mp="2xgdx8vuu4j70">ENGLISH READY™</span>
              </p>
              <p className="mt-0.5 text-[9px] font-bold uppercase tracking-[0.12em] text-ink/35" data-id="element-165" data-mp="2sn1l3l7ce4v5">
                Verified purchase · {item.time}
              </p>
            </div>
            <button type="button" onClick={() => setIsDismissed(true)} aria-label="Dismiss notification" className="ml-auto shrink-0 rounded-full p-1 text-ink/30 transition-colors hover:text-ink focus:outline-none focus-visible:ring-2 focus-visible:ring-brand/40" data-id="element-166" data-mp="2jny0gcsj1hej">
              <XIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-167" data-mp="37bfl7oddjf80" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}